import { IAsyncAction, IAction } from '@state/types';
import { Tags } from '@state/templates/types';

export enum PermissionEnum {
  'VIEW',
  'EDIT',
  'PUBLIC_VIEW',
  'NONE'
};

export enum DesignPermissionEnum {
  VIEW = "VIEW",
  EDIT = "EDIT",
}

/* Data models */
export interface DuplicateDesignInfo {
  id: string;
  userData: UserData;
  updateFolderCounter?: boolean;
  keepFolder?: boolean;
}

export interface ICreateFromTemplate {
  design: IDesign;
}

export interface CreateTemplateFromDesignInfo {
  idDesign: string;
  designName: string;
  userData: UserData;
}

export interface UserData {
  email: string;
  name: string;
}

export interface Preview {
  name: string;
  url: string;
  size?: string;
}

export interface CustomTags {
  name: string;
}

export interface IDesign {
  id: string;
  entityType: string;
  name : string;
  parsedTree : string;
  previews: Preview[];
  createdDate: Date;
  updateDate: Date;
  createdBy: UserData;
  updatedBy: UserData;
  designStatus: string;
  folder?: string;
  favorite: boolean;
  tags: Tags;
}

export interface IDesignAuth {
  id: string;
  action?: string;
  message?: string;
  from?: UserData;
  usersPermission?: UserPermission[];
}

export interface IRequestAccess {
  design: IDesign;
  user: UserData;
  permission: DesignPermissionEnum;
}

export interface IUserRequestAccess {
  email?: string | null;
  permission?: DesignPermissionEnum | null;
}

export interface UserPermission {
  email: string;
  permission: PermissionEnum;
}

export interface Field {
  field: string;
  value: any;
}
export interface UpdateInfo {
  filter: string;
  fields: Field[];
}

/* Reducer types */
export interface IDesignsState {
  designs?: IDesign;
  design?: IDesign;
  designAuth?: IDesignAuth;
  designAuthMailErrors?: string[];
  designResponse?: {};
  designSearches?: IDesign;
  designFavoriteResponse?: {};
  counterDesigns?: {};
  counterSharedFiles?: {};
}

/* Actions types */
export interface IDuplicateDesignAction extends IAsyncAction {
  duplicateDesignInfo: DuplicateDesignInfo;
}

export interface ICreateFromTemplateAction extends IAsyncAction {
  designRequest: ICreateFromTemplate;
}

export interface ICreateTemplateFromDesignAction extends IAsyncAction {
  createTemplateFromDesignInfo: CreateTemplateFromDesignInfo;
}

export interface IFetchDesignsAction extends IAsyncAction {
  query?: string;
}

export interface IPostDesignAction extends IAsyncAction {
  design: IDesign;
}

export interface IFetchDesignAction extends IAsyncAction {
  query?: string;
}

export interface IFetchDesignAuthAction extends IAsyncAction {
  id: string;
}

export interface IFetchSearchAction extends IAsyncAction {
  query?: string;
}

export interface IFetchCounterAction extends IAsyncAction {
  filter?: string;
}

export interface IFetchDesignCountersAction extends IAsyncAction {
  userEmail: string;
  sharedFiles: boolean;
}

export interface IUpdateDesignAction extends IAsyncAction {
  design: IDesign;
  location: string;
  updateFolderCounter?: Boolean;
}

export interface IUpdateDesignDeleteAction extends IAsyncAction {
  design: IDesign;
  location: string;
  updateFolderCounter?: Boolean;
}

export interface IUpdateDesignAuthAction extends IAsyncAction {
  designAuth: IDesignAuth;
}

export interface IRequestAccessAction extends IAsyncAction {
  designAccess: IRequestAccess;
}

export interface IRequestAccessResponse extends IAsyncAction {
  design: IDesign;
  errors: string[];
}

export interface IUpdateDesignsAction extends IAsyncAction {
  designs: IDesign[];
}

export interface IUpdateDesignsFieldsAction extends IAsyncAction {
  updateInfo: UpdateInfo;
}

export interface IServerErrorAction extends IAction {
  error: any;
}

export interface IServerSuccessAction extends IAction {
  designResponse: {};
}

export interface IDesignFavoriteSuccessAction extends IAction {
  designFavoriteResponse: {};
}

export interface IDesignAuthSuccessAction extends IAction {
  designAuth: IDesignAuth;
  designAuthMailErrors?: string[];
}

export interface ISetDesignsAction extends IAction {
  designs: IDesign;
}

export interface ISetDesignAction extends IAction {
  design: IDesign;
}

export interface ISetDesignActionAuth extends IAction {
  designAuth: IDesignAuth;
  designAuthMailErrors?: string[];
}

export interface ISetSearchAction extends IAction {
  designSearches: IDesign;
}

export interface ISetDesignCountersAction extends IAction {
  counter: {};
}

export interface ISetCounterAction extends IAction {
  counterDesigns: {};
}

export interface ISetCounterSharedFilesAction extends IAction {
  counterSharedFiles: {};
}